// extracted by mini-css-extract-plugin
module.exports = {"callout":"Callout-module--callout--3prvw"};